import {createMuiTheme} from '@material-ui/core/styles';

let theme = createMuiTheme({
  direction: 'rtl',
  typography: {
    useNextVariants: true,
    fontFamily: 'IranSans',
      // fontSize: 12,
      h1: {
        fontSize: '1.5rem',
        letterSpacing: '-0.05rem',
        fontWeight: 'bold',
        lineHeight: '2'
      },
      h3: {
        fontSize: 16,
        lineHeight: '28px'
      },
      // body2: {
      //   fontSize: '2.815rem',
      //   lineHeight: 2,
      //   color: '#424953',
      // }
    },
    spacing: {
      unit: 16
    },
    shape: {
      borderRadius: 2
    },
    subtitle1: {
        color: '#fff'
    },
    // shadows.,
    palette: {
      text: {
        secondary: 'rgba(0, 0, 0, 0.65)'
      },
      categoryScopes: {
        3: {
          primary: {
            // 50: '#e0eff7',
            50: '#eef9ff',
            100: '#b3d6eb',
            200: '#80bbdd',
            300: '#4da0cf',
            400: '#268bc5',
            500: '#0077bb',
            600: '#006fb5',
            700: '#0064ac',
            800: '#005aa4',
            900: '#004796',
            A100: '#c1daff',
            A200: '#8ebbff',
            A400: '#5b9dff',
            A700: '#418eff',
            'contrastDefaultColor': 'light',
          },
        },
        5: {
          primary: {
            50: '#f9eadb',
            100: '#e3cfbb',
            200: '#d0af8d',
            300: '#bd8e5f',
            400: '#af763d',
            500: '#a15e1b',
            600: '#995618',
            700: '#8f4c14',
            800: '#854210',
            900: '#743108',
            A100: '#ffc1a4',
            A200: '#ff9f71',
            A400: '#ff7c3e',
            A700: '#ff6b25',
            'contrastDefaultColor': 'light',
          },
        },
        6: {
          primary: {
            50: '#eff7ce',
            100: '#d3d9b9',
            200: '#b5bf8a',
            300: '#97a55b',
            400: '#819237',
            500: '#6b7f14',
            600: '#637712',
            700: '#586c0e',
            800: '#4e620b',
            900: '#3c4f06',
            A100: '#d9ff83',
            A200: '#c9ff50',
            A400: '#baff1d',
            A700: '#b2ff04',
            'contrastDefaultColor': 'light',
          },
        },
        7: {
          primary: {
            50: '#fff9d8',
            100: '#e4dcb3',
            200: '#d2c580',
            300: '#bfad4d',
            400: '#b29c27',
            500: '#a48a01',
            600: '#9c8201',
            700: '#927701',
            800: '#896d01',
            900: '#785a00',
            A100: '#ffe5a6',
            A200: '#ffd673',
            A400: '#ffc740',
            A700: '#ffbf26',
            'contrastDefaultColor': 'light',
          },
        },
        8: {
          primary: {
            50: '#ffebeb',
            100: '#f0b3b3',
            200: '#e68080',
            300: '#db4d4d',
            400: '#d42626',
            // 500: '#cc0000',
            500: '#c8280a',
            600: '#c70000',
            700: '#c00000',
            800: '#b90000',
            900: '#ad0000',
            A100: '#ffd7d7',
            A200: '#ffa4a4',
            A400: '#ff7171',
            A700: '#ff5858',
            'contrastDefaultColor': 'light',
          },
        },
        10: {
          primary: {
            50: '#f2edfc',
            100: '#ddcef7',
            200: '#c6aef2',
            300: '#af8eec',
            400: '#9d75e8',
            500: '#8c5de4',
            600: '#8455e1',
            700: '#794bdd',
            800: '#6f41d9',
            900: '#5c30d1',
            A100: '#ffffff',
            A200: '#e9e2ff',
            A400: '#c3afff',
            A700: '#b096ff',
            'contrastDefaultColor': 'light',
          },
        },
        12: {
          primary: {
            50: '#fdf5e3',
            100: '#fbe5b9',
            200: '#f8d38a',
            300: '#f5c15b',
            400: '#f3b437',
            500: '#f1a714',
            600: '#ef9f12',
            700: '#ed960e',
            800: '#eb8c0b',
            900: '#e77c06',
            A100: '#ffffff',
            A200: '#ffecdb',
            A400: '#ffd2a8',
            A700: '#ffc48f',
            'contrastDefaultColor': 'light',
          },
        },
        13: {
          primary: {
            50: '#e6ebf3',
            100: '#c5ccda',
            200: '#9fabc1',
            300: '#7989a8',
            400: '#5c6f95',
            500: '#3f5682',
            600: '#394f7a',
            700: '#31456f',
            800: '#293c65',
            900: '#1b2b52',
            A100: '#91afff',
            A200: '#5e8aff',
            A400: '#2b65ff',
            A700: '#1253ff',
            'contrastDefaultColor': 'light',
          },
        },
        16: {
          primary: {
            50: '#fef3f0',
            100: '#f7c8b9',
            200: '#f2a48a',
            300: '#ed7f5b',
            400: '#e96337',
            500: '#e54814',
            600: '#e24112',
            700: '#de380e',
            800: '#da300b',
            900: '#d32106',
            A100: '#fffcfc',
            A200: '#ffcec9',
            A400: '#ff9f96',
            A700: '#ff887c',
            'contrastDefaultColor': 'light',
          },
        },
        17: {
          primary: {
            50: '#f0f7f9',
            100: '#D5E8EE',
            200: '#bfe0e8',
            300: '#a5d3df',
            400: '#91C8D7',
            500: '#67ABBD',
            600: '#5AA3B5',
            700: '#5B9EB3',
            800: '#5899AE',
            900: '#4991A8',
            A100: '#ffffff',
            A200: '#e0f7ff',
            A400: '#adebff',
            A700: '#94e4ff',
            'contrastDefaultColor': 'light',
          },
        },
        18: {
          primary: {
            50: '#fff3f9',
            100: '#f3b4d7',
            200: '#ec83bc',
            300: '#e451a1',
            400: '#de2b8d',
            500: '#d80679',
            600: '#d40571',
            700: '#ce0466',
            800: '#c8035c',
            900: '#bf0249',
            A100: '#ffe7ef',
            A200: '#ffb4cc',
            A400: '#ff81a9',
            A700: '#ff6897',
            'contrastDefaultColor': 'light',
          },
        }
      },
    }
  });

// const shadows = {
//   ...theme.shadows,
//   [1]: '1px 1px 3px #F5F5F5'
// };
theme.shadows[1] = '1px 1px 3px #F5F5F5';
// theme = {...theme, shadows}
// console.log(theme);
export default theme;